'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.carousel.list', [])
  .controller('CarouselListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/carousel/list/index.js